<template>
  <div class="bg-[#353535]">
    <div
      class="w-full p-4 sm:px-8 gap-4 flex items-center justify-between bg-capino-light z-[1]"
      :class="{ 'rounded-t-3xl': !isDemo }"
    >
      <BaseInput
        id="sections-header-search"
        :value="filters.search"
        class="w-full"
        icon="search"
        :placeholder="$t('hub.sections.search')"
        @input="handleSearch"
      />
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput.vue'

export default {
  name: 'HubSectionsHeader',

  components: { BaseInput },

  props: {
    filters: { type: Object, required: true },
    isDemo: { type: Boolean, default: false }
  },

  methods: {
    handleSearch(value) {
      this.$emit('update:filters', {
        ...this.filters,
        search: value,
        sectionSlug: 'all'
      })
    }
  }
}
</script>
